import styled from 'styled-components';
import {BGImageCenter} from '../../../../globalVariables/GlobalVariables';
import {dFlexCenter} from '../../../../globalVariables/GlobalFlex';
type TProps = {
    $icon: string;
    $color: string;
    $size: number;
}
const circle = styled.div<TProps>`
    ${dFlexCenter}
    border-radius: 50%;
    margin: auto;
`;
// Outer wrapper
export const IconOuterCircle = styled(circle)`
    width: ${p=>p.$size+60}px;
    height: ${p=>p.$size+60}px;
    background-color: ${p=>p.$color}1A;
`;

// Middle layer
export const IconMiddleCircle = styled(circle)`
    width: ${p=>p.$size+30}px;
    height: ${p=>p.$size+30}px;
    background-color: ${p=>p.$color}33;
`;

// Inner cover
export const IconInnerCircle = styled(circle)`
    width: ${p=>p.$size}px;
    height: ${p=>p.$size}px;
    background-color: ${p=>p.$color};

`;

// Icon itself
export const IconSymbol = styled.div<TProps>`
    width: ${p=>p.$size}px;
    height: ${p=>p.$size}px;
    transform: scale(1);
    opacity: 0.7;
    background-color: transparent;
    ${p=>BGImageCenter(p.$icon, '16px')}
`;